import { render, staticRenderFns } from "./DocumentoTipo.vue?vue&type=template&id=20d0ee52&scoped=true"
import script from "./DocumentoTipo.vue?vue&type=script&setup=true&lang=js"
export * from "./DocumentoTipo.vue?vue&type=script&setup=true&lang=js"
import style0 from "./DocumentoTipo.vue?vue&type=style&index=0&id=20d0ee52&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20d0ee52",
  null
  
)

export default component.exports